module.exports = __webpack_public_path__ + "img/2-1.e0e4866f.svg";